/**
 *
 * @param {File} file The File object that is to be encoded
 * @returns {Promise<String>} Base64 representation
 */
export default function(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function() {
      // console.log(reader.result);
      let encoded = reader.result.replace(/^data:(.*;base64,)?/, '')

      // ref: https://stackoverflow.com/questions/4080988/why-does-base64-encoding-require-padding-if-the-input-length-is-not-divisible-by
      if (encoded.length % 4 > 0) {
        encoded += '='.repeat(4 - (encoded.length % 4))
      }
      resolve(encoded)
    }
    reader.onerror = function(error) {
      console.log('Error: ', error)
      reject(error)
    }
  })
}
